import { PDFViewer } from '@react-pdf/renderer';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import DraftH from '../../cetak/draft/DraftH';
import FormH from '../../cetak/hc/FormH';
import DraftSPTEvaluasi from '../../cetak/draft/DraftSPTEvaluasi';
import DraftLHVerifikasi from '../../cetak/draft/DraftLHVerifikasi';
import DraftSPTEvaluasiTeknis from '../../cetak/draft/DraftSPTEvaluasiTeknis';
import DraftLHEvaluasi from '../../cetak/draft/DraftLHEvaluasi';
import DraftSPTPencetakanDraft from '../../cetak/draft/DraftSPTPencetakanDraft';
import { QRCodeCanvas } from 'qrcode.react';
import MasterService from '../../../services/master/MasterService';
import FormA from '../../cetak/hc/FormA';
import FormB from '../../cetak/hc/FormB';
import FormD from '../../cetak/hc/FormD';
import FormE from '../../cetak/hc/FormE';
import FormF from '../../cetak/hc/FormF';
import FormG from '../../cetak/hc/FormG';
import DraftA from '../../cetak/draft/DraftA';
import DraftB from '../../cetak/draft/DraftB';
import DraftD from '../../cetak/draft/DraftD';
import DraftE from '../../cetak/draft/DraftE';
import DraftF from '../../cetak/draft/DraftF';
import DraftG from '../../cetak/draft/DraftG';
import DraftKuitansi from '../../cetak/draft/DraftKuitansi';
import DraftC from '../../cetak/draft/DraftC';
import DraftNZ from '../../cetak/draft/DraftNZ';
import FormC from '../../cetak/hc/FormC';

const ModalCetak = ({ showCetak, handleCloseCetak, dataDisposisi, datappm }) => {

    const [qrImage, setQrImage] = useState(null)
    const qrImageCanvas = useRef()
    const qrText = "https://siapmutu.kkp.go.id/view-smkhp/"+datappm.nomorAju
    const [kdHcm, setKdHcm] = useState('')

    let masterService = useMemo(() => new MasterService(), [])

    const getQRCodeDataURL = (canvasRef) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                const canvas = canvasRef.current?.children[0]; // Get the canvas inside <QRCode />
                if (canvas) {
                    resolve(canvas.toDataURL("image/png")); // Convert to Base64
                } else {
                    resolve(null);
                }
            }, 500); // Delay to ensure QR code renders
        });
    };

    useEffect(() => {
        const generateQrCode = async () => {
            const dataUrl = await getQRCodeDataURL(qrImageCanvas)
            setQrImage(dataUrl)
        }
        generateQrCode()
    }, [])

    useEffect(() => {
        if (!datappm) return
        const getKodeHcm = async () => {
            const resKd = await masterService.getNegaraById(datappm.negaraPartner)
            setKdHcm(resKd.data.kdHcm)
        }
        getKodeHcm()
    }, [masterService, datappm])

    return (
        <>
            <div ref={qrImageCanvas} style={{ display: "none" }}>
                <QRCodeCanvas value={qrText} size={100} />
            </div>

            <Modal
                show={showCetak}
                onHide={handleCloseCetak}
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Body>
                    <PDFViewer style={{ width: 1105, height: 800 }}>
                        {
                            dataDisposisi.idDisposisi === 9 && datappm.peruntukan === "1" &&
                            (
                                (
                                    kdHcm === 'H' && <DraftH dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'A' && <DraftA dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'B' && <DraftB dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'C' && <DraftC dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'D' && <DraftD dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'E' && <DraftE dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'F' && <DraftF dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'G' && <DraftG dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                // ) ||
                                // (
                                //     kdHcm === 'NZ' && <DraftNZ />
                                ) 
                            )
                        }
                        {
                            dataDisposisi.idDisposisi === 9 && datappm.peruntukan === "2" &&
                            (
                                <DraftH dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                            )
                        }
                        {
                            dataDisposisi.idDisposisi === 11 && datappm.peruntukan === "2" &&
                            (
                                <FormH dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                            )
                        }
                        {
                            dataDisposisi.idDisposisi === 11 && datappm.peruntukan === "1" &&
                            (
                                (
                                    kdHcm === 'H' && <FormH dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'A' && <FormA dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage}/>
                                ) ||
                                (
                                    kdHcm === 'B' && <FormB dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'C' && <FormC dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'D' && <FormD dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'E' && <FormE dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'F' && <FormF dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                ) ||
                                (
                                    kdHcm === 'G' && <FormG dataDisposisi={dataDisposisi} datappm={datappm} qrImage={qrImage} />
                                )
                            )
                        }
                        {
                            dataDisposisi.idDisposisi === 2 &&
                            <DraftSPTEvaluasi dataDisposisi={dataDisposisi} datappm={datappm} />
                        }
                        {
                            dataDisposisi.idDisposisi === 3 &&
                            <DraftLHVerifikasi dataDisposisi={dataDisposisi} datappm={datappm} />
                        }
                        {
                            dataDisposisi.idDisposisi === 4 &&
                            <DraftSPTPencetakanDraft dataDisposisi={dataDisposisi} datappm={datappm} />
                        }
                        {
                            dataDisposisi.idDisposisi === 5 &&
                            <DraftSPTEvaluasiTeknis dataDisposisi={dataDisposisi} datappm={datappm} />
                        }
                        {
                            dataDisposisi.idDisposisi === 8 &&
                            <DraftLHEvaluasi dataDisposisi={dataDisposisi} datappm={datappm} />
                        }
                        {
                            dataDisposisi.idDisposisi === 10 &&
                            <DraftKuitansi dataDisposisi={dataDisposisi} datappm={datappm}/>
                        }
                    </PDFViewer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCetak